import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";
import { defineComponent } from "vue";
import Tools from "@/shared/services/tools";


const name = 'ParcelasPedidosCanceladosLiquidados'

export default defineComponent({
  name,

  components: {
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    PedidoEmAndamentoPDF
  },

  props: {},

  mounted() {
    this.getDetalhesDoPedido();
    this.GetParcelas();
  },

  updated() { },

  data() {
    return {
      PedidoId: null,
      renderiza: false,
      executarvisualizacao: 0,
      parcelasInfo: [],
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
      numeroParcela: '',
      dataBasePedidoParcela: '',
      codigoExternoCliente:'',
      codigoPedido:'',
      componentePedidoParcelaArray: [],
      podeGerarPdf: false,
    }
  },

  methods: {
    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },
    
    imprimir()
    {
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      
      if(this.podeGerarPdf) {
        this.executarvisualizacao++
      }
    },

    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++
      }, "500");
    },

    voltar() {
      this.$router.push(`/pedido-em-andamento-fluxo/${this.$route.params.id}/detalhes-pedido-andamento`);
    },


    getDetalhesDoPedido() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },


    GetParcelas() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetParcelasPedidosEmAndamento/${this.$route.params.id}`,
      })
        .then((response) => {
          this.codigoPedido = response.data.data[0].codigoExterno;
          this.componentePedidoParcelaArray = response.data.data[0].componentePedidoParcelaArray;
          this.parcelasInfo = response.data.data;
          this.numeroParcela = response.data.data.numeroParcela;
          this.pedidoParcelaId = response.data.data.pedidoParcelaId;
          this.indicadorTexto = response.data.data.indicadorTexto;
          //this.GetComponentes();
        })
        .catch(() => {
        });
    },

    // GetComponentes(){
    //   this.axios({
    //     method: 'get',
    //     url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidosComponentesParcela/${this.$route.params.id}`,
    //   })
    //     .then((response) => {
    //     })
    //     .catch(() => {
    //     });

    // },

    notasFiscaisRota(codigoPedido,numeroParcela) {
      if(codigoPedido != null){
        this.$router.push(`/notas-fiscais/${codigoPedido}/${numeroParcela}`)
      }
    },

    observacoesRota(numeroParcela) {
      //this.mitt.emit('apareceTab', 4)
      this.$router.push(`/pedido-em-andamento-fluxo/${this.$route.params.id}/${numeroParcela}/observacoes-pedido-andamento`)
    },

    instrucoesCarregamentoRota(numeroParcela) {
      //this.mitt.emit('apareceTab', 5)
      this.$router.push(`/pedido-em-andamento-fluxo/${this.$route.params.id}/${numeroParcela}/instrucoes-carregamento-pedido-andamento`)
    },

    historicoRota(pedidoParcelaId,numeroParcela) {
      //this.mitt.emit('apareceTab', 1)
      this.$router.push(`/pedido-em-andamento-fluxo/${pedidoParcelaId}/${numeroParcela}/historico-pedido-andamento`)
    },

  },

  computed: {}
});